import { SET_USER_NOTIFICATIONS, SIGNOUT_USER, SERVER_MARK_NOTIFICATION_AS_SEEN } from 'constants/ActionTypes';

const INITIAL_STATE = {
	chatNotifications: [],
	generalNotifications: [],
	loading: {
		chatNotifications: true,
		generalNotifications: true
	}
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case SIGNOUT_USER:
			return INITIAL_STATE;
		case SET_USER_NOTIFICATIONS:
			return {
				...state,
				chatNotifications: action.payload.chatNotifications,
				generalNotifications: action.payload.generalNotifications,
				loading: {
					...state.loading,
					chatNotifications: false,
					generalNotifications: false
				}
			};
		case SERVER_MARK_NOTIFICATION_AS_SEEN:
			return {
				...state,
				chatNotifications: state.chatNotifications.map(notification =>
					notification.notificationId === action.payload.notificationId
						? { ...notification, highlighted: false }
						: notification
				),
				generalNotifications: state.generalNotifications.map(notification =>
					notification.notificationId === action.payload.notificationId
						? { ...notification, highlighted: false }
						: notification
				)
			};
		default:
			return state;
	}
};



// WEBPACK FOOTER //
// ./reducers/Notifications.js